export default "__VITE_ASSET__d6455d8f__"